import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const confidencePulsePlugin = createPlugin({
  id: 'confidence-pulse',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindPulseRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidencePulsePlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidencePulsePage = confidencePulsePlugin.provide(
  createRoutableExtension({
    name: 'ConfidencePulsePage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-pulse", webpackPrefetch: 5 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
